<script setup>
import TicketForm from '@frontJs/components/forms/projectManagement/tasks/TicketForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { ticketStatuses, ticketPriorities, ticketThemes, tenant, tenants } =
    defineProps({
        ticketStatuses: {
            required: true,
            type: Array,
        },
        ticketPriorities: {
            type: Array,
            required: true,
        },
        ticketThemes: {
            type: Array,
            required: true,
        },
        tenant: {
            type: Object,
            required: false,
        },
        tenants: {
            type: Array,
            required: true,
        },
    });

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>
            Créer un ticket Apikom - Tickets Apikom - Tâches - Gestion de projet
            - Datakepler
        </title>
    </Head>

    <PageTitle>
        Gestion de projet - Tâches - Tickets Apikom - Créer un ticket Apikom
    </PageTitle>

    <TicketForm
        :ticket-statuses="ticketStatuses"
        :ticket-priorities="ticketPriorities"
        :ticket-themes="ticketThemes"
        :tenant="tenant"
        :tenants="tenants"
    />
</template>
